// extracted by mini-css-extract-plugin
export default {"container":"LSEForm_container__B5Ovz","link":"LSEForm_link__pU41g"};